//
export const veeRule = {
  enrichment: "#34C759",
  filter: "#e6c01c",
  flow: "#7e7d7d",
  transformation: "#3294c2",
  external: "#FF9500",
  action: "#F65B5B",
  input: "#54990E",
  white: "#ffffff",
  black: "#000000",
};

export const billRule = {
  generation: "#3F51B5", // Indigo – professional, stable, for generation
  validation: "#8E24AA", // Purple – audit/validation tone
  adjustment: "#009688", // Teal – balance/correction feel
  dueReminder: "#C62828", // Deep Red – urgency/reminder
  approval: "#5E35B1", // Violet – authority/approval
  payment: "#00695C", // Dark Teal – trustworthy, financial
  reversal: "#AD1457", // Magenta – reversal/rollback
  reporting: "#283593", // Deep Blue – analytics/reporting
};
